<template>
  <li
    @click.stop="showBackstage"
    name="open-remote-control"
    v-aha-emit-action="{
      source: 'PresentingView',
      stage_type: canUseRemoteControl ? 'remote-control' : 'backstage'
    }"
    class="sidebar-item pointer"
  >
    <a class="text-wrap sidebar-link-custom sidebar-link waves-effect waves-dark">
      <span class="horizontal layout center">
        <aha-icon
          :name="canUseRemoteControl ? 'aha-remote' : 'aha-backstage'"
          class="sidebar-link-icon text-transparent"
          strokeColor
          maintainColor
          width="24"
          height="24"
          viewBox="0 0 16 16"
        />
        <span class="hide-menu nav-left-text">{{ canUseRemoteControl ? $i18nPresenter.t('Open Remote Control')
          : $t('Show backstage') }}</span>
      </span>
    </a>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/eventBus'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  computed: {
    ...mapGetters('remoteControlLink', ['canUseRemoteControl']),
  },
  methods: {
    showBackstage() {
      EventBus.$emit('open-backstage-window', 'from-context-menu')
      utils.mixpanelTracking(
        eventCategories.PRESENTING_MODE,
        'Context menu > Show backstage',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.sidebar-item {
  width: unset;
  .sidebar-link {
    &:hover {
      .fas, .far {
        color: $primary-color;
      }
    }
    .sidebar-link-icon {
      font-size: 20px;
      margin-right: 12px;
    }
  }
  .active {
    background-color: rgba(0, 0, 0, 0.07);
  }
  .nav-left-text {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-size: 16px;
  }
}
</style>
